import PagePermission from "components/page_permission";
import Home from "src/views/home";

const HomePage = () => {
  return (
    <PagePermission>
      <Home />
    </PagePermission>
  );
};

export default HomePage;
